import React from "react";
// import ImgSrcBackgroundImageDesktop from "../assets/img/health-support/speakToTherapist_2222x1242.jpg";
import ImgSrcBackgroundImageDesktop from "../assets/img/msk/mskbgImg.jpg";
// import ImgSrcBackgroundImageTablet from "../assets/img/health-support/speakToTherapist_955x875.jpg";
// import ImgSrcBackgroundImageMobile from "../assets/img/health-support/speakToTherapist_580x400.jpg";
import styles from "../assets/css/modules/health-support/working-body.css";
// import { getPhoneClaims } from "../helpers/ContentStateHelper";
import Physio from "../assets/img/msk/physioImage.png";
import Appointment from "../assets/img/msk/appoinment.png";
// import { Urls } from "./../constants/UrlConstants";
import Vector from "../assets/img/msk/Vector.png";
import HOLVector from "../assets/img/msk/HolVector.png";
import { Link } from "react-router-dom";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { Paths } from "./../constants/UrlConstants";
import PhysioMob from "../assets/img/Gp27/physio_mob.png";
import AppointmentMob from "../assets/img/msk/appointmentMob.png";

export default {
  Heading: "Speak to a physiotherapist",
  BackgroundDesktopImage: ImgSrcBackgroundImageDesktop,
  BackgroundTabletImage:  ImgSrcBackgroundImageDesktop,
  BackgroundMobileImage: ImgSrcBackgroundImageDesktop,
  HeroContent: {
    Any: (
      <React.Fragment>
        {/* <h1>Speak to a physiotherapist</h1> */}
        <h1>You can't postpone back pain or schedule a sprain</h1>
        <p>
          Get the help you need; we’ve made sure you can speak to an expert fast. 
        </p>
        <ul className={styles.listStyle}>
          <li>You can have a video or phone appointment with a physiotherapist or
            specialist without a GP referral </li>
          <li>This service is available to members
            <strong> aged 18 and over. </strong></li>
        </ul>
          <p>
          We’re working with HBSUK, a specialist-led online service that is part of the AXA Group.
        </p>
        {/* <p>
          With Working Body, you can arrange a phone call with a physiotherapist
          about all types of conditions that affect bones, joints and muscle,
          without the need for a GP referral first.
        </p>
        <p>
          The physiotherapist will assess your symptoms, discuss with you what
          they mean then either recommend an exercise program or what to do next
          if you need treatment.
        </p>
        <p>To get started, give us a call:</p> */}
      </React.Fragment>
    ),
      },
      LargeCorporate: {
        Any:(
        <React.Fragment>
            <h1>You can't postpone back pain or schedule a sprain</h1>
            <p>
              Get the help you need; we’ve made sure you can speak to an expert fast.
            </p>
            <ul className={styles.listStyle}>
              <li>You can have a video or phone appointment with a physiotherapist or
                specialist without a GP referral </li>
              <li>This service is available to members
                <strong> aged 18 and over. </strong></li>
            </ul>
            <p>
              Most of our members have access to this service, please check your employer has
              selected the muscle, bone and joint digital service by referring to the Working Body
              section in your{" "} 
              <Link
                className={layoutStyle.anchorDecorationUnderline}
                to={Paths.CoverDocuments}
              >
                handbook.
              </Link>
            </p>
            <p>
              We’re working with HBSUK, a specialist-led online service that is part of the AXA Group.
            </p>
        </React.Fragment>
          )
    },
  ButtonLeftLabel:"BOOK AN APPOINTMENT",
  ButtonRightLabel:"HOW IT WORKS",

  PhysioSection:
  {
    IconSrc: Physio,
    IconSrcMobile : PhysioMob,
    Heading : "How to book an appointment",
    Description : (
      <React.Fragment>
        <div><p><b>Get started</b><br />Select 'Book an appointment' below. When you do this, we'll share your membership 
        information and contact details with HBSUK.</p></div>
      <div><p><b>Fill in a few details</b><br />This is an online form that normally takes about 10 minutes to complete.
        The team uses your answers to make sure you get to the treatment and care that’s right for you.</p></div>
      <div><p><b>Set up a video or phone appointment</b><br />You can choose an appointment at a time that suits you (appointments are available Monday to Friday).</p></div>
      </React.Fragment>
    ),
  },
  AppointmentSection:
  {
    IconSrc : Appointment,
    IconSrcMobile :  AppointmentMob,
    Heading : "When you have your appointment",
    Description: (
    <React.Fragment>
      <div><p><b>You’ll have a video or phone appointment</b><br />Your physiotherapist or specialist will talk through your symptoms,
        assess you and work out what could be wrong.</p></div>
      <div><p><b>They’ll advise you on next steps</b><br />For example, you may need a personalised exercise plan. You’ll be able to view and track your exercises,
        see your documents and manage your appointments from your HBSUK online account.</p></div>
      <div><p><b>If you need a face-to-face appointment, or more treatment</b><br />Sometimes the team may advise further treatment or tests - they’ll help you choose which.
        That could be a face-to-face appointment, a scan or an x-ray.</p></div>
    </React.Fragment> 
    ),
  },
  AppointmentHelpSection:{
    AppointmentHelpText:<div><p><b>If this happens</b><br />You’ll need the appropriate healthcare benefits for the recommended next steps - outpatient specialist consultations, diagnostic tests or hands-on physiotherapy. Any outpatient limits or contribution you normally pay towards treatment each year will apply. 
    Please check your membership documents to find out what benefits you have access to.</p></div>
  },
  // HeroContentPhoneNumbers: {
  //   Any: (props) => (
  //     <p className={styles.phoneNumber}>
  //       <strong>{getPhoneClaims(props)}</strong>
  //     </p>
  //   ),
  //   LargeCorporate: (props) => (
  //     <p className={styles.phoneNumber}>
  //       <strong>{getPhoneClaims(props)}</strong>
  //     </p>
  //   )
  // },
  // HeroContentContactHours: {
  //   Any: (
  //     <p className={styles.openingHours}>
  //       Monday-Friday: 8am-8pm, Saturday: 9am-5pm
  //     </p>
  //   ),
  //   HOLMOL: <p className={styles.openingHours}>Monday - Friday 8am-6pm</p>
  // },
  // StepHeader: "How does it work?",
  // StepGiveUsACall: {
  //   Any: (props) => (
  //     <React.Fragment>
  //       <h3 className={styles.workingBodyHeading}>Give us a call</h3>
  //       <p>
  //         Call our Personal Advisers on <strong>{getPhoneClaims(props)}</strong>{" "}
  //         and let them know what your concern is. They will let you know if you
  //         are eligible for treatment, then arrange for you to speak with a
  //         physiotherapist.
  //       </p>
  //     </React.Fragment>
  //   ),
  //   LargeCorporate: (props) => (
  //     <React.Fragment>
  //       <h3 className={styles.workingBodyHeading}>Give us a call</h3>
  //       <p>
  //         Call our Personal Advisers on <strong>{getPhoneClaims(props)}</strong>{" "}
  //         and let them know what your concern is. They will let you know if you
  //         are eligible for treatment, then arrange for you to speak with a
  //         physiotherapist.
  //       </p>
  //     </React.Fragment>
  //   )
  // },
  // StepSpeakToPhysio: (
  //   <React.Fragment>
  //     <h3 className={styles.workingBodyHeading}>
  //       Speak to a Working Body physiotherapist
  //     </h3>
  //     <p>
  //       You will receive a call from a physiotherapist who will assess your
  //       symptoms and talk to you about what they could mean.
  //     </p>
  //   </React.Fragment>
  // ),
  // StepTreatment: (
  //   <React.Fragment>
  //     <h3 className={styles.workingBodyHeading}>Treatment</h3>
  //     <p>
  //       If the physiotherapist thinks exercises could ease your pain, they'll
  //       recommend some you can try at home. And if you need further treatment,
  //       they'll help you plan what to do next.
  //     </p>
  //   </React.Fragment>
  // )
  HelpSet: [
    {
      // Question: "Is Working Body included as part of my plan?",
      // Answer: (
      //   <React.Fragment>
      //      <p>
      //       Any member with private healthcare cover* can access the Working
      //       Body helpline and get access to expert physiotherapy services
      //       without the need to see your GP first. When you first call us, we'll
      //       let you know if you're covered for treatment.
      //     </p>
      //     <p>
      //       If you're covered and the physiotherapist recommends hands-on
      //       physiotherapy, we'll arrange a suitable time and place for your
      //       course of treatment.
      //     </p>
      //     <p>
      //       {" "}
      //       If you're not covered for treatment, you can still get expert advice
      //       on self-management from our qualified physiotherapists. They can
      //       suggest exercises to get you back to your best and things you can do
      //       to ease your symptoms.
      //     </p>

      //     <p> *excluding those on a child-only or Cashback plan</p>
      //   </React.Fragment>
      // )
      
 Question: "Is this included in my membership?",
 Answer: (
          <p>
            Access to video or phone appointments are included as part of your membership. 
            If you need any face-to-face appointments or tests however, 
            you’ll need the appropriate outpatient benefits. Any outpatient limits or 
            contribution you normally make towards treatment each year will also apply.
          </p>
          )
    },
    {
      // Question: "Do I need to see my GP before calling you for Working Body?",
      // Answer: (
      //   <p>
      //     No, with Working Body, you can arrange a phone call with a
      //     physiotherapist about all types of conditions that affect bones,
      //     joints and muscles, to make sure you're getting the advice and
      //     treatment that's right for you. You don't even need to see your GP
      //     first.
      //   </p>
      // )
      Question: "What happens if my GP has recommended seeing a physiotherapist or specialist (such as an orthopaedic consultant) already?",
      Answer: (
        <p>
          You can still use this online service while you’re waiting for NHS treatment, or 
          alongside the NHS treatment.
           It doesn’t matter whether you have an NHS GP referral or not.
        </p>
      )
    },
    {
      // Question: "Where will I go for my physiotherapy treatment?",
      // Answer: (
      //   <p>
      //     If you need a course of hands-on physiotherapy, we'll advise a plan of
      //     treatment to meet your needs. For example, we can arrange for you to
      //     see a fully-qualified physiotherapist at a clinic that's convenient
      //     for you to get to from our directory.
      //   </p>
      // )
      Question: "How will a video or phone call help?",
      Answer: (
        <p>
         The physiotherapists and specialists are trained to make sure 
         they can assess you on a video or phone call, and they’ll advise you on exercises that could help. 
         However, if they think you need to see someone face-to-face, they’ll let you know.
        </p>
      )
    }
  ],
LinkSection: {
  LinkText : "VIEW MORE FREQUENTLY ASKED QUESTIONS",
  HBSPrivacyPolicy: "HBSUK PRIVACY POLICY",
  LinkImag : <div><img  src={Vector} alt="" aria-hidden></img></div>,
  LinkImagHol : <div><img  src={HOLVector} alt="" aria-hidden></img></div>
}
};
